import React, { ReactNode, createContext, useContext, useState } from "react";

interface FocusedFieldManagerContextI {
  setFocused: (fieldId: string) => void;
  focusedId: string | null;
  showRequiredErrors: boolean;
  setShowRequiredErrors: (value: boolean) => void;
}

const FocusesFieldManagerContext = createContext<FocusedFieldManagerContextI | undefined>(undefined);

export const useFocusedFieldManager = () => {
  const ctx = useContext(FocusesFieldManagerContext);
  if (!ctx) return null;
  return ctx;
};

interface FocusedFieldManagerProviderProps {
  children: ReactNode;
  showRequiredErrors?: boolean;
}

export const FocusedFieldManagerProvider: React.FC<FocusedFieldManagerProviderProps> = ({
  children,
  showRequiredErrors: controlledShowRequiredErrors,
}) => {
  const [focusedId, setFocusedId] = useState<string | null>(null);
  const [uncontrolledShowRequiredErrors, setUncontrolledShowRequiredErrors] = useState(false);

  const showRequiredErrors = controlledShowRequiredErrors ?? uncontrolledShowRequiredErrors;

  const setFocused = (id: string) => {
    setFocusedId(id);
  };

  return (
    <FocusesFieldManagerContext.Provider
      value={{ setFocused, focusedId, showRequiredErrors, setShowRequiredErrors: setUncontrolledShowRequiredErrors }}
    >
      {children}
    </FocusesFieldManagerContext.Provider>
  );
};
